import { useNavigate, useRouter } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

type DrawerSearchParam =
  | "vehicleId"
  | "officeId"
  | "contactId"
  | "proDriverId"
  | "relocationPageId";

export function useCloseSearchDrawer(param: DrawerSearchParam) {
  const router = useRouter();
  const navigate = useNavigate();
  const entryOpenedOverPage = useRef<string | undefined>(undefined);

  useEffect(
    () =>
      router.subscribe("onResolved", ({ fromLocation, toLocation }) => {
        if (!fromLocation) {
          return;
        }

        const fromSearch = fromLocation.search as Record<string, unknown>;
        const toSearch = toLocation.search as Record<string, unknown>;
        const isOpenedOverSamePage =
          !fromSearch[param] &&
          !!toSearch[param] &&
          fromLocation.pathname === toLocation.pathname &&
          toLocation.state.__TSR_index === fromLocation.state.__TSR_index + 1;

        if (isOpenedOverSamePage) {
          entryOpenedOverPage.current = toLocation.state.__TSR_key;
        }
      }),
    [router, param],
  );

  return function closeDrawer() {
    const currentEntry = router.state.location.state.__TSR_key;

    if (currentEntry && currentEntry === entryOpenedOverPage.current) {
      router.history.back();
      return;
    }

    navigate({
      to: ".",
      search: (prev: Record<string, unknown>) => ({
        ...prev,
        [param]: undefined,
      }),
      replace: true,
    });
  };
}
